function getInitials(id, institutions) {
  const institution = institutions.find((value) => value._id === id);

  return institution?.initials;
}

export { getInitials };
